import React from 'react';
import {Button, Col, Row} from 'antd';
import { t } from 'i18next';
import FormSlider from "../../elements/FormSlider";
import {GetClientType} from "../../../config";
const ShowMoreSection = ({  profileType, showMoreOptions, selectedProduct,renderOptions,setRenderOptions,browser }) => {
    if (GetClientType() !== "3dmax" || !showMoreOptions || profileType !== "all") return null;

    return (
        <>
            <Row>
                <Col xs={24} sm={24} md={12} lg={12} className='color-slider'>
                    <div className='slider-back'>
                        <div className="slider-back-title">{t('product.color')}</div>
                        <div className='product-color-range'></div>
                        <FormSlider key={selectedProduct?.id + "hue_shift"}
                                    title={t('product.hue_shift')} min={-180} max={180}
                                    defaultValue={renderOptions.hue_shift}
                                    onChange={(value) => {
                                        var newRenderOptions = renderOptions;
                                        newRenderOptions.hue_shift = value;
                                        setRenderOptions(newRenderOptions);
                                    }}
                        />
                        <FormSlider key={selectedProduct?.id + "saturation"}
                                    title={t('product.saturation')} min={-100} max={100}
                                    defaultValue={renderOptions.saturation}
                                    onChange={(value) => {
                                        var newRenderOptions = renderOptions;
                                        newRenderOptions.saturation = value;
                                        setRenderOptions(newRenderOptions);
                                    }}
                        />
                    </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <div className='slider-back'>
                        <div className="slider-back-title">{t('product.lightness')}</div>
                        <FormSlider key={selectedProduct?.id + "brightness"}
                                    title={t('product.brightness')} min={-100} max={100}
                                    defaultValue={renderOptions.brightness}
                                    onChange={(value) => {
                                        var newRenderOptions = renderOptions;
                                        newRenderOptions.brightness = value;
                                         setRenderOptions(newRenderOptions);
                                    }}
                        />
                        <FormSlider key={selectedProduct?.id + "contras"} title={t('product.contras')}
                                    min={-100} max={100} defaultValue={renderOptions.contras}
                                    onChange={(value) => {
                                        var newRenderOptions = renderOptions;
                                        newRenderOptions.contras = value;
                                        setRenderOptions(newRenderOptions);
                                    }}
                        />

                    </div>
                </Col>
            </Row>
            <Button type="primary" className='apply-button' style={{marginTop: 20}}
                    onClick={() => {
                        browser.apply(selectedProduct, renderOptions.hue_shift, renderOptions.saturation, renderOptions.brightness, renderOptions.contras)
                    }}
            >
                {t('product.apply')}
            </Button>
        </>
    );
};

export default ShowMoreSection;
